import { webTypeApiUrl } from "@/constants/webTypeApiUrl";

export const FriendDetailHandler = {
  Hello: function () {
    alert("FriendDetailHandler.js");
  },
  getChatRoomUrl: function (chatRoomId, token) {
    $.ajax({
      url: webTypeApiUrl.MessageAPI + "/Friend/getChatRoomUrl",
      type: "post",
      cache: false,
      async: false,
      data: {
        chatRoomId: chatRoomId,
        token: token
      },
      success: function (data) {
        if (data == "") {
          alert("連結已失效");
        } else {        
          var a = $("<a>", {
            href: data + "&tct=" + token
          });
          a.prop("hash");
          window.location.href = a.prop("hash");
          window.location.reload();
        }
      },
      error: function (a, b, c) {
        alert(a);
        alert(b);
        alert(c);
        window.location.href = "/#/Error";
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/handler/FriendDetailHandler.js